import { environment } from 'environments/environment';

interface PropertyValue {
  value: any;
  expire: number;
}

/* STATE */
export interface PropertyState {
  [key: string]: PropertyValue;
}

/* SELECTORS */
export const selectProperty = (name: string) => {
  return environment.properties[name];
};

export const selectProperties = (names: string[]): Record<string, any> => {
  return names.reduce(
    (acc, name) => ({
      ...acc,
      [name]: environment.properties[name],
    }),
    {}
  );
};
